export const maxScrollTop = (dom) => dom.scrollHeight - dom.clientHeight;
